import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Cloudhighdemand() {
  return (
    <section className="cloud_high_demand p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <h2>
              Why Trust TekRevol for Cloud{" "}
              <span>Computing Consulting Services</span>
            </h2>
            <p>
              Whether planning your first cloud migration or optimizing existing
              operations, TekRevol ensures your business excels at every stage.
            </p>
            {/* <ul>
              <li>
                <strong>6+ Years</strong> of expertise in cloud consultation,
                development, cost-optimization, & migration.
              </li>
              <li>
                <strong>8+ Years</strong> of experience as a leading software
                development company in the USA.
              </li>
              <li>
                Recognized by <strong>INC. 5000 and INC. 5000 Regionals</strong>{" "}
                for the Southwest Region among the fastest growing companies
                list.
              </li>
              <li>
                Received <strong>ISO 27001 Certification</strong> for top-notch
                information security management across service channels.
              </li>
              <li>
                Recognized as a{" "}
                <strong>Reliable Tech Solutions Provider by Clutch</strong> with
                75+ reviews.
              </li>
              <li>
                Known for sustainable digital enablement, accelerated tech
                transformation, and growth expansion expertise with a{" "}
                <strong>5.0 Rating on GoodFirms </strong> and a{" "}
                <strong>4.8 Rating on RightFirms.</strong>
              </li>
            </ul> */}
            <h5>Proven Cloud Expertise</h5>
            <p>
              Our experts deliver industry-specific cloud solutions for
              healthcare, finance, and e-commerce, ensuring high reliability and
              efficiency tailored to your business needs.
            </p>
            <h5>Continuous Innovation & Improvement</h5>
            <p>
              Our team integrates cutting-edge technologies and methodologies,
              providing up-to-date solutions that keep your business competitive
              and ready for future advancements.
            </p>
            <h5>Strategic Cost Management</h5>
            <p>
              We optimize your cloud spending through effective resource
              allocation and cost management strategies, maximizing ROI without
              compromising performance.
            </p>
            <h5>Accelerated Deployment</h5>
            <p>
              Our agile deployment process reduces your time to market, ensuring
              rapid implementation of cloud solutions to seize new business
              opportunities quickly.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center my-auto"
          >
            <StaticImage
              src="../../images/services-usa/cloud-new/cloud_high_demand.webp"
              alt="cloud computing services"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={600}
              height={652}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Cloudhighdemand;
